import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const Text = styled.span`
  text-align: center;
`;

export const CTAButton = styled.button<{
  primary?: boolean;
  buttonClass: string;
}>`
  width: 317px;
  height: 58px;
  border: 1px solid ${COLORS.black};
  background-color: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: 'Audi Type';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.black};
  cursor: pointer;
  ${({ buttonClass }) => {
    if (buttonClass === 'loadMore')
      return css`
        background-color: ${COLORS.black};
        color: ${COLORS.white};
      `;

    if (buttonClass === 'viewDetails')
      return css`
        width: 285px;
        height: 46px;
        font-size: 12px;
        line-height: 20px;
      `;

    if (buttonClass === 'edit')
      return css`
        border: none;
        width: unset;
        color: ${COLORS.grey90};
        @media ${device.laptop} {
          border: 1px solid ${COLORS.black};
          width: 206px;
        }
        font-size: 12px;
        line-height: 20px;
        @media ${device.laptop} {
          font-size: 16px;
          line-height: 24px;
        }
      `;
    return css``;
  }}
`;

export const EditLocationCTA = styled.button<{
  primary?: boolean;
  buttonClass: string;
}>`
  background-color: ${COLORS.white90};
  display: inline-flex;
  padding: ${SIZING.unit(0.5)} ${SIZING.unit(1.5)};
  align-items: flex-start;
  gap: 8px;
  font-family: 'Audi Type';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  align-items: center;
  color: ${COLORS.black};
  cursor: pointer;
  border: none;
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.003px;
  }
  ${({ buttonClass }) => {
    if (buttonClass === 'editLocation')
      return css`
        // background-color: ${COLORS.black};
        // color: ${COLORS.white};
      `;
    return css``;
  }}
`;

export const TextCTA = styled.button<{
  primary?: boolean;
  buttonClass: string;
}>`
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  font-family: 'Audi Type';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  align-items: center;
  color: ${COLORS.black};
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: ${SIZING.unit(0)};
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.003px;
  }
  ${({ buttonClass }) => {
    if (buttonClass === 'back')
      return css`
        gap: 6px;
        @media ${device.tablet} {
          gap: 12px;
        }
        padding: ${SIZING.unit(0.125)} ${SIZING.unit(0)};
        &.noGap {
          gap: 0;
        }
      `;
    return css``;
  }}
  ${({ buttonClass }) => {
    if (buttonClass === 'gpsCta')
      return css`
        @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
          font-size: 12px;
        }
      `;
    return css``;
  }}
`;
